import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { hexCodeFromName } from 'modules/shift_management/lib/colors'

class DefaultShiftForm extends Form {
  constructor(values: Record<string, string | number> = {}) {
    super(values, {
      title: 'string',
      color: 'string',
      color_name: 'string',
      start_at: 'string',
      end_at: 'string',
      location_id: 'number',
      work_area_id: 'number',
      notes: 'string',
      all_company: 'boolean',
      teams_ids_visibilities: 'any',
      locations_ids_visibilities: 'any',
      saved_from_custom: 'boolean',
      extra_hours: 'boolean',
    })

    this.setValues({
      color_name: 'olive1000',
      color: hexCodeFromName('olive1000'),
      extra_hours: false,
    })

    makeObservable(this, {
      isValid: computed,
      isValidFromCustom: computed,
      isValidTime: computed,
      startAt: computed,
      endAt: computed,
      isVisibilitySelected: computed,
      isSavedFromCustom: computed,
    })
  }

  get isValid(): boolean {
    const isValidTitle = this.get('title').value.length > 0
    return this.isDirty && isValidTitle && this.isValidTime && this.isVisibilitySelected
  }

  get isValidFromCustom(): boolean {
    const isValidTitle = this.get('title').value.length > 0
    return this.isDirty && isValidTitle && this.isVisibilitySelected
  }

  get isValidTime(): boolean {
    const regEx = new RegExp(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)
    const isValidStartTime = regEx.test(this.get('start_at').value)
    const isValidEndTime = regEx.test(this.get('end_at').value)
    return isValidEndTime && isValidStartTime
  }

  get startAt() {
    return moment(this.get('start_at').value, 'HH:mm')
  }

  get endAt() {
    return moment(this.get('end_at').value, 'HH:mm')
  }

  get isVisibilitySelected(): boolean {
    const allCompany = this.get('all_company').value
    const teamsIdsVisibilities = this.get('teams_ids_visibilities').value.length
    const locationsIdsVisibilities = this.get('locations_ids_visibilities').value.length

    return !!allCompany || !!teamsIdsVisibilities || !!locationsIdsVisibilities
  }

  get isSavedFromCustom(): boolean {
    return this.get('saved_from_custom').value
  }

  validateSavedFromCustom(): boolean {
    this.resetErrors()

    if (!this.isSavedFromCustom) return true

    if (!this.get('title').value.length) {
      this.get('title').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_saved_name'),
      ])
    }

    if (!this.isVisibilitySelected) {
      this.get('all_company').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_visibility'),
      ])
    }

    return !this.hasErrors
  }
}

export default DefaultShiftForm
